<script>
  import { BaseEdge, EdgeLabel } from "@xyflow/svelte";
  import * as d3 from "d3";

  export let data;
  export let markerEnd;
  export let style = "stroke-width: 2; stroke:black";
  let path;
  let labelPosition;
  let labelLines = [];

  $$restProps;

  $: labelPosition = calculateLabelPosition(data.points);
  $: path = createEdgePath(trimEdgePoints(data.points));
  $: labelLines = String(data.label || "")
    .split("\n")
    .filter((line) => line && line !== "undefined");

  function createEdgePath(points) {
    const line = d3
      .line()
      .curve(d3.curveMonotoneY)
      .x((d) => d.x)
      .y((d) => d.y);

    return line(points);
  }

  function trimEdgePoints(points) {
    if (!points || points.length < 2) return points;
    const trimmed = points.map((point) => ({ ...point }));
    trimPoint(trimmed[0], trimmed[1]);
    trimPoint(trimmed[trimmed.length - 1], trimmed[trimmed.length - 2]);
    return trimmed;
  }

  function trimPoint(point, neighbor) {
    const dx = neighbor.x - point.x;
    const dy = neighbor.y - point.y;
    const length = Math.hypot(dx, dy);
    if (!length) return;
    const inset = 10;
    point.x += (dx / length) * inset;
    point.y += (dy / length) * inset;
  }

  function calculateLabelPosition(points) {
    const middleIndex = Math.floor(points.length / 2);
    if (points.length % 2 === 0) {
      return {
        x: (points[middleIndex - 1].x + points[middleIndex].x) / 2,
        y: (points[middleIndex - 1].y + points[middleIndex].y) / 2,
      };
    }
    return { x: points[middleIndex].x, y: points[middleIndex].y };
  }

</script>

<BaseEdge {path} {markerEnd} {style} />
<EdgeLabel>
  <div
    style:transform="translate(-50%, -50%) translate({labelPosition.x}px,{labelPosition.y}px)"
    class="edge-label"
    class:graph_dimmed={data.dimmed}
    data-edge-id={data.id}
  >
    <svg class="edge-label-icon" viewBox="0 0 20 20" aria-hidden="true">
      <path d="M3 14 L7 9 L11 12 L16 5" />
      <circle cx="7" cy="9" r="1.4" />
      <circle cx="11" cy="12" r="1.4" />
      <circle cx="16" cy="5" r="1.4" />
    </svg>
    <span class="edge-label-text">
      <span class="edge-label-main">{labelLines[0]}</span>
    </span>
  </div>
</EdgeLabel>

<style>
  .edge-label {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    background: white;
    color: #000;
    padding: 8px 12px;
    min-width: max-content;
  }

  .graph_dimmed {
    opacity: 0.22;
  }

  .edge-label-icon {
    width: 18px;
    height: 18px;
    flex: 0 0 18px;
  }

  .edge-label-icon path {
    fill: none;
    stroke: #36a852;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .edge-label-icon circle {
    fill: #36a852;
  }

  .edge-label-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.05;
  }

  .edge-label-main {
    font-size: 14px;
    font-weight: 700;
  }

  :global(.svelte-flow__edgelabel-renderer) {
    z-index: 100 !important;
  }

  :global(.svelte-flow__edges) {
    z-index: 50 !important;
  }
</style>
